import * as React from 'react';
import { Link, Search, useNavigate } from 'react-router-dom';
import * as Models from '../models/index';
import { useContext, useEffect, useReducer } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Button, Col, FormGroup, Row, Spinner } from 'reactstrap';
import { formatDate } from '../utils';
import { Formik, FormikErrors, FormikProps, FormikValues } from 'formik';
import * as FormUtils from '../components/formUtils/index';
import UserELPService from '../services/UserELPService';
import { UserELPUsers } from '../models/UserELPUsers';
import AuthenticationContext from '../components/context/AuthenticationContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, regular, brands, icon } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used

const PAGE_SIZE = 10;

type State = {
    canLoadMore: boolean;
    isLoading: boolean;
    isNoResults: boolean;
    items: UserELPUsers[];
    totalItems: number;
    searchTrigger: number;
    sortOrder: string;
}

const initialState: State = {
    canLoadMore: false,
    isLoading: false,
    isNoResults: false,
    items: [],
    totalItems: 0,
    searchTrigger: 0,
    sortOrder: "dateadded"
}

export const ELPSearch = () => {

    const navigate = useNavigate();

    const [state, setState] = useReducer(
        (prevState: State, newState: Partial<State>) => ({ ...prevState, ...newState }),
        initialState
    );

    const search = async () => {

        setState({
            isLoading: true            
        });

        // 
        const result = await UserELPService.listAll(state.sortOrder);

        if (!result.hasErrors) {
            setState({
                items: result.value.items,
                totalItems: result.value.totalItems,
                isNoResults: result.value.totalItems == 0,
                isLoading: false,
                canLoadMore: result.value.totalItems > result.value.items.length
            })
        }

    }

    const loadMore = async () => {
        setState({
            isLoading: true
        });

        const result = await UserELPService.listAll(state.sortOrder);

        if (!result.hasErrors) {

            const newItemsSet = state.items.concat(result.value.items);

            setState({
                items: newItemsSet,
                totalItems: result.value.totalItems,
                isLoading: false,
                canLoadMore: result.value.totalItems > newItemsSet.length
            })
        }
    }

    const setSortOrder = (sortOrder: string) => {
        setState({ sortOrder: sortOrder });
        search();
    }

    useEffect(() => {

        search();
    
    }, [])

    return <>
        <h1>English Language Proficiency</h1>

        <InfiniteScroll
            pageStart={0}
            loadMore={loadMore}
            hasMore={state.canLoadMore && !state.isLoading}
            useWindow={false}
            className=""
        ><div className="table-responsive mt-3">
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>First Name</th>
                            <th><a href="javascript:void();" onClick={() => setSortOrder('lastname')}>Last Name {state.sortOrder === 'lastname' ? '(sorted alphabetically)' : ''}</a></th>
                            <th><a href="javascript:void();" onClick={() => setSortOrder('dateadded')}>Date Added {state.sortOrder === 'dateadded' ? '(sorted by newest)' : ''}</a></th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {state.items.map((item, index) => <tr key={item.userELPId} className="cursor-pointer">
                            <td>{index + 1}</td>
                            <td><Link to={`/admin-elp-edit/${item.userProfileId}`}>{item.firstName}</Link></td>
                            <td><Link to={`/admin-elp-edit/${item.userProfileId}`}>{item.lastName}</Link></td>
                            <td><Link to={`/admin-elp-edit/${item.userProfileId}`}>{item.dateAdded.toString()}</Link></td>
                            <td>
                                {item.elp != null && <div>ELP 1 Status: {item.elp}</div>}
                                {item.elp2 != null && <div>ELP 2 Status: {item.elp2}</div>}
                                {item.elp3 != null && <div>ELP 3 Status: {item.elp3}</div>}
                            </td>
                        </tr>)}
                        {state.isNoResults &&
                            <tr>
                                <td colSpan={5}>No Results</td>
                            </tr>
                        }
                        {state.isLoading &&
                            <tr>
                                <td colSpan={5}>
                                    <Spinner color="primary" size="sm" />
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </InfiniteScroll>
    </>

};
